import { apiClient } from "@/services/apiClient";
import type { PagedResult } from "./physicalRecordsApi";

export interface PhysicalCategory {
  categoryId: number;
  legacyCategoryId: string;
  categoryName: string;
  sourceObjectCount: number;
  sourceAttributeRowCount: number;
}

export interface PhysicalCategoryAttribute {
  categoryAttributeId: number;
  legacyCategoryId: string;
  legacyAttributeId: number;
  attributeName: string;
  regionName: string;
  setName: string | null;
  sourceAttributeType: number | null;
  reportingLevel: number | null;
}

export interface PhysicalObjectCategory {
  objectCategoryId: number;
  legacyCategoryId: string;
  categoryName: string;
  definitionVersion: number;
  objectVersion: number;
  sourceAttributeRowCount: number;
}

export interface PhysicalCategoryValue {
  categoryValueId: number;
  objectCategoryId: number;
  legacyCategoryId: string;
  definitionVersion: number;
  objectVersion: number;
  legacyAttributeId: number;
  attributeName: string | null;
  regionName: string | null;
  setName: string | null;
  sourceAttributeType: number | null;
  customId: string | null;
  entryNum: number | null;
  parentKeyId: string | null;
  keyId: string | null;
  valueInt: string | null;
  valueReal: number | null;
  valueDate: string | null;
  valueString: string | null;
  valueLong: string | null;
}

const BASE = "/api/physical-records";
export const categoryPaths = {
  definitions: `${BASE}/admin/categories`,
  attributes: (categoryId: number) => `${BASE}/admin/categories/${categoryId}/attributes`,
  assignments: (objectId: number) => `${BASE}/objects/${objectId}/categories`,
  values: (objectId: number, assignmentId: number) => `${BASE}/objects/${objectId}/categories/${assignmentId}/values`,
};

export async function getPhysicalCategoryPage<T>(path: string, page: number, search: string, signal: AbortSignal): Promise<PagedResult<T>> {
  return (await apiClient.get<PagedResult<T>>(path, { params: { page, pageSize: 50, search: search || undefined }, signal })).data;
}